import { Theme } from "@mui/material";
import { createContext, useContext } from "react";

interface CustomThemeContextType {
  custom: Theme;
  isDarkMode: boolean;
  toggleDarkMode: () => void;
}

const CustomThemeContext = createContext<CustomThemeContextType | undefined>(
  undefined
);

export function useCustomThemeContext() {
  const context = useContext(CustomThemeContext);
  if (context === undefined) {
    throw new Error("useCustomThemeContext must be used within a ThemeProvider");
  }
  return context;
}

export default CustomThemeContext;

